import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

/**
 * Componente SEO para gerenciar metadados de cada página
 * Gerencia título, descrição, palavras-chave, Open Graph e Twitter Cards
 */
const SEO: React.FC<SEOProps> = ({ 
  title = 'Boardverso', 
  description = 'Plataforma para amantes de jogos de tabuleiro', 
  image = '/logo.png',
  url = '' 
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SEO; 